import * as React from "react";
import Header from "./header-default";
import Desc from "./desc-default";
import Map from "./map-component";
import Layout from "../../layout/layout";
export default class DescDefault extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let supplier = this.props.supplier;
        return (React.createElement(Layout, { route: '' },
            React.createElement(Header, { supplier: this.props.supplier }),
            React.createElement(Desc, { supplier: this.props.supplier }),
            React.createElement(Map, { location: { lat: this.props.supplier.Latitude, lng: this.props.supplier.Longitude } })));
    }
}
;
//# sourceMappingURL=default-view.js.map